import { ITranslations } from 'types/common';
import { BrandsTransFields } from './types';
import en from 'translations/en/brands.json';
import pl from 'translations/pl/brands.json';
import sl from 'translations/sl/brands.json';

export const brandsTranslations: ITranslations<BrandsTransFields> = {
  name: 'brands',
  en,
  pl,
  sl,
};
